module.exports = __webpack_public_path__ + "img/49.71d71737.jpg";